import { WALLETINVOICES } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WALLETINVOICES.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
